import React from "react";

import "./page.scss";

const Page = ({ children }) => <div className="Page">{children}</div>;

export default Page;
